// extracted by mini-css-extract-plugin
export default {"container":"mouse-follow_container__T-ID5"};